import { GET_ALL_LABS_ORDER, GET_ALL_MEDICINES_ORDER } from './constants';
import fetchWithRefresh from './fetchWithRefresh';
import { Profile } from './switchDoctor';
import { Data as MedicineData } from './getMedicinesOrder';
import { Address, CollectionSlot, EditOrderConfig, Data as LabData } from './getLabTestsOrder';
import { AppointmentDetails } from './fetchInvoice';
import { ACTIVE_TAB, ActiveTab } from '../pages/HEDashboard';

export interface Response {
    success: boolean;
    allOrders: Order[];
    error?: string;
}

export interface Order {
    status: string;
    sub_status?: string;
    prescription_id: string;
    created_at?: string;
    amount?: number;
    paidAmount?: number;
    platformdiscount?: number;
    last_visit_time: string;
    patient: Profile;
    order_details?: OrderDetails;
    appointment_details: AppointmentDetails;
    order_id: string;
    service_id: string;
    patient_name?: string;
    patient_id?: string;
    order_status?: string;
    delivered_early_by?: string;
    type?: string;
    external_remarks?: string[];
    current_order_status?: string;
    updated_at?: string;
    customer_details?: {
        age: number;
        name: string;
        gender: string;
        mobile: string;
        address_details: Address;
    };
    report_document_id?: string;
    pxid?: string;
    vendorid?: string;
    vendorname?: string;
    collection_date: string;
    collection_slot: CollectionSlot;
    orderName?: string;
    edit_order_config: EditOrderConfig;
}

export type OrderDetails = MedicineData | LabData;

type Payload = {
    startDate: string;
    endDate: string;
};

export default (
    docIds: string,
    startDate: string,
    endDate: string,
    activeTab: ActiveTab,
): Promise<Response> => {
    const payload: Payload = {
        startDate: startDate,
        endDate: endDate,
    };
    if (activeTab !== ACTIVE_TAB.MEDS && activeTab !== ACTIVE_TAB.LABS) {
        return Promise.reject(new Error('Invalid order type'));
    }
    return fetchWithRefresh(
        activeTab === ACTIVE_TAB.MEDS
            ? GET_ALL_MEDICINES_ORDER(docIds)
            : GET_ALL_LABS_ORDER(docIds),
        {
            method: 'POST',
            body: JSON.stringify(payload),
            headers: {
                'Content-type': 'application/json',
            },
        },
    ).then((res) => res.json());
};
